import React from 'react';
import {LINK_EXT} from 'constants/index';

import * as styles from './styles.module.scss';

interface SocialIconProps {
	link: string;
	Icon: React.ReactElement;
}

const SocialIcon: React.FC<SocialIconProps> = ({Icon, link}) => {
	return (
		<a href={link} className={styles.icon} {...LINK_EXT()}>
			{Icon}
		</a>
	);
};

export default SocialIcon;
